import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ArquivoPropostaService } from 'src/app/services/arquivo-proposta.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-variaveis-arquivo-proposta-modal',
  templateUrl: './variaveis-arquivo-proposta-modal.component.html',
  styleUrls: ['./variaveis-arquivo-proposta-modal.component.scss']
})
export class VariaveisArquivoPropostaModalComponent implements OnInit {
  variaveis = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialogRef: MatDialogRef<VariaveisArquivoPropostaModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private arquivoPropostaService: ArquivoPropostaService
  ) { }

  ngOnInit(): void {
    this.buscarVariaveis();
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.arquivoPropostaService.consultarVariaveis().subscribe(
      (variaveis) => {
        this.variaveis = variaveis;
        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );

  }

  fechar() {
    this.dialogRef.close();
  }
}
